import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { MessageSquare, FileText, Users } from 'lucide-react';
import { ExpiringDocumentsCard } from './ExpiringDocumentsCard';

export const OverviewTab = ({ ctx }) => {
  const { apiUrl, password, inquiries, quotes, referrals, getStatusBadge, formatDate, setViewingAgentDocs } = ctx;
  return (
    <div className="space-y-6">
      <ExpiringDocumentsCard apiUrl={apiUrl} adminPassword={password} onViewAgent={(id, name) => setViewingAgentDocs({ id, name })} />
      <div className="grid md:grid-cols-3 gap-6">
        {/* Recent Inquiries */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center">
              <MessageSquare className="h-5 w-5 mr-2 text-blue-600" />
              Recent Inquiries
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {inquiries.slice(0, 5).map((inquiry) => (
                <div key={inquiry.id} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex justify-between items-start">
                    <p className="font-medium text-sm">{inquiry.name}</p>
                    {getStatusBadge(inquiry.status)}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">{inquiry.subject}</p>
                  <p className="text-xs text-gray-400 mt-1">{formatDate(inquiry.created_at)}</p>
                </div>
              ))}
              {inquiries.length === 0 && (
                <p className="text-gray-500 text-sm text-center py-4">No inquiries yet</p>
              )}
            </div>
          </CardContent>
        </Card>

        {/* Recent Quotes */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center">
              <FileText className="h-5 w-5 mr-2 text-green-600" />
              Recent Quote Requests
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {quotes.slice(0, 5).map((quote) => (
                <div key={quote.id} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex justify-between items-start">
                    <p className="font-medium text-sm">{quote.name}</p>
                    {getStatusBadge(quote.status)}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    {quote.insurance_type === 'life' ? 'Life' : quote.insurance_type === 'critical' ? 'Critical Illness' : 'Visitor'} - ${quote.coverage_amount?.toLocaleString()}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">{formatDate(quote.created_at)}</p>
                </div>
              ))}
              {quotes.length === 0 && (
                <p className="text-gray-500 text-sm text-center py-4">No quotes yet</p>
              )}
            </div>
          </CardContent>
        </Card>

        {/* Recent Referrals */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center">
              <Users className="h-5 w-5 mr-2 text-purple-600" />
              Recent Referrals
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {referrals.slice(0, 5).map((referral) => (
                <div key={referral.id} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex justify-between items-start">
                    <p className="font-medium text-sm">
                      {referral.client_first_name} {referral.client_last_name}
                    </p>
                    {getStatusBadge(referral.status)}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Referred by: {referral.referrer_name}
                  </p>
                  <p className="text-xs text-gray-400 mt-1">{formatDate(referral.created_at)}</p>
                </div>
              ))}
              {referrals.length === 0 && (
                <p className="text-gray-500 text-sm text-center py-4">No referrals yet</p>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default OverviewTab;
